import { ActionTree } from "vuex"
import { RootState } from "./types/state"
import {
  getOrders,
  getRefundOrderList,
  getOrdersCount,
  getOrdersWithCount,
} from "@/api/net/order"
import { OrderStatus } from "@/types/enum/OrderEnum"
import { formatterDate } from "../libs/utils"
import { IOrderDto, IOrderPayload } from "@/types/interface/IOrderDto"
import { IOrderCancellationRequestDto } from "@/types/interface/IOrderCancellationRequestDto.ts"
import store from "@/store"
import {
  IOrderCountDto,
  IOrderCountForStatus,
} from "../types/interface/IOrderDto"
import BigNumber from "bignumber.js"
import { IGetMerchOrdersRequest } from "@/types/request/IGetMerchOrdersRequest"

export type IResultOrders = { orderList: Array<IOrderDto>; total: number }

window.OrderListTimer = null
window.HistoryOrdersTimer = null

export const getMerchorders = async (
  toParams: any,
  orderStatuses: OrderStatus[]
) => {
  let params = Object.assign(
    {
      orderStatuses,
      skip: 5,
      take: 5,
    },
    toParams
  )
  params["orderCacheMinutes"] = store.state.orderCacheMinutes
  params["merchId"] = store.state.merchId
  params["merchIds"] = store.state.merchIds
  params["OrderCountStatuses"] = [
    OrderStatus.WaitingForAcceptance,
    OrderStatus.CancelRejected,
    OrderStatus.Refunding,
    OrderStatus.Refunded,
    OrderStatus.Processing,
    OrderStatus.Ready,
    OrderStatus.Delivering,
    OrderStatus.Completed,
    OrderStatus.Rejected,
    OrderStatus.Cancelled,
    OrderStatus.BadSale,
    OrderStatus.CancelRequested,
  ]
  params["ShowAllLiveOrders"] = true // 是否显示全部未完成订单
  let { data } = await getOrdersWithCount(params["merchId"], params)
  if (store.state.inPreOrderTab && !store.state.preOrderDate) {
    store.commit("handleOrderTotal", 0)
  } else {
    store.commit("handleOrderTotal", data.result.total)
  }
  store.commit(
    "handleOrderStatusCount",
    OrderStatusToOrderStatusCountMapping([data.result.orderCountForStatus])
  )
  store.commit("handlePreOrderCountForDate", data.result.preordersCountForDate)
  return data.result.orders.reduce((arrOrder: IOrderDto[], x: IOrderDto) => {
    let isExistItemIndex = arrOrder.findIndex((o) => o.id === x.id)
    if (isExistItemIndex > -1) {
      arrOrder.splice(isExistItemIndex, 1, x)
      return arrOrder
    }
    return [...arrOrder, x]
  }, [])
  // .sort(
  //   (a: IOrderDto, b: IOrderDto): number =>
  //     new Date(b.orderDate).getTime() - new Date(a.orderDate).getTime()
  // )
}

export const getMerchordersCount = async (toParams: IGetMerchOrdersRequest) => {
  let params = Object.assign(
    {
      orderStatuses: [
        OrderStatus.WaitingForAcceptance,
        OrderStatus.CancelRejected,
        OrderStatus.Refunding,
        OrderStatus.Refunded,
        OrderStatus.Processing,
        OrderStatus.Ready,
        OrderStatus.Delivering,
        OrderStatus.Completed,
        OrderStatus.Rejected,
        OrderStatus.Cancelled,
        OrderStatus.BadSale,
        OrderStatus.CancelRequested,
      ],
    },
    {
      ...toParams,
      startFilterDate: formatterDate(
        new Date(new Date().getTime() - 3600000 * 24 * 5).toUTCString()
      ),
      endFilterDate: formatterDate(
        new Date(new Date().getTime() + 3600000 * 24 * 1).toUTCString()
      ),
      filterType: 0,
    }
  )

  if (store.state.isPc) {
    const requests = store.state.merchIds.map((x: string) => {
      params = { ...params, ...{ merchId: x } }
      return getOrdersCount(params, { merchId: x })
    })
    try {
      let ordersCountArray = (await Promise.all(
        requests
      )) as IOrderCountForStatus[]
      store.commit(
        "handleOrderStatusCount",
        OrderStatusToOrderStatusCountMapping(ordersCountArray)
      )
      return
    } catch (error) {
      store.commit("handleOrderStatusCount", {
        Pending: 0,
        WaitingForAcceptance: 0,
        Processing: 0,
        Ready: 0,
        Delivering: 0,
        Completed: 0,
        Rejected: 0,
        Cancelled: 0,
        BadSale: 0,
        CancelRequested: 0,
        CancelRejected: 0,
        Refunding: 0,
        Refunded: 0,
      })
      return
    }
  }
  params["merchId"] = store.state.merchId
  let orderCountForStatus: IOrderCountForStatus = await getOrdersCount(params)
  store.commit(
    "handleOrderStatusCount",
    OrderStatusToOrderStatusCountMapping([orderCountForStatus])
  )
  store.commit("handleShowLoading", false)
}

const OrderStatusToOrderStatusCountMapping = (
  orderCountForStatusArray: IOrderCountForStatus[]
): IOrderCountDto => {
  return orderCountForStatusArray.reduce(
    (orderCount: IOrderCountDto, orderCountForStatus: IOrderCountForStatus) => {
      return orderCount.map((x) => {
        switch (x.mappingFiled) {
          case "LIVE ORDERS":
            x.count = new BigNumber(orderCountForStatus.WaitingForAcceptance)
              .plus(orderCountForStatus.Processing)
              .plus(orderCountForStatus.Ready)
              .plus(orderCountForStatus.Delivering)
              .plus(x.count)
              .toNumber()
            break
          case "Completed":
            x.count = new BigNumber(x.count)
              .plus(orderCountForStatus.Completed)
              .plus(orderCountForStatus.Cancelled)
              .plus(orderCountForStatus.CancelRejected)
              .toNumber()
            break
          default:
            x.count = new BigNumber(x.count)
              // @ts-ignore
              .plus(orderCountForStatus[x.mappingFiled])
              .toNumber()
            break
        }
        return x
      })
    },
    [
      { mappingFiled: "LIVE ORDERS", text: "LIVE ORDERS", count: 0 },
      { mappingFiled: "PRE ORDER", text: "PRE ORDER", count: 0 },
      { mappingFiled: "Refunding", text: "Refunding", count: 0 },
      { mappingFiled: "WaitingForAcceptance", text: "Incoming", count: 0 },
      { mappingFiled: "Processing", text: "Preparing", count: 0 },
      { mappingFiled: "Ready", text: "Ready", count: 0 },
      { mappingFiled: "Delivering", text: "Delivering", count: 0 },
      { mappingFiled: "Completed", text: "Completed", count: 0 },
      { mappingFiled: "Rejected", text: "Rejected", count: 0 },
    ]
  )
}

export enum pullOrderDefaultUrl {
  orderUrl = "home/order",
  historyUrl = "home/history",
}

const actions: ActionTree<RootState, any> = {
  cancelTimer() {
    window.OrderListTimer = null
  },
  async handleOrderList({ commit, state }, payload: IOrderPayload) {
    let toParams = {
      page: payload.page,
      keyword: payload.keyword,
      merchId: "",
      ExcludePreOrderStatuses: payload.ExcludePreOrderStatuses,
    }

    toParams = Object.assign(toParams, {
      filterType: 0,
      CountFilterType: 0,
      startFilterDate: formatterDate(
        new Date(new Date().getTime() - 3600000 * 24 * 5).toUTCString()
      ),
      endFilterDate: formatterDate(
        new Date(new Date().getTime() + 3600000 * 24 * 1).toUTCString()
      ),
      CountStartFilterDate: formatterDate(
        new Date(new Date().getTime() - 3600000 * 24 * 5).toUTCString()
      ),
      CountEndFilterDate: formatterDate(
        new Date(new Date().getTime() + 3600000 * 24 * 1).toUTCString()
      ),
    })
    if (payload.keyword) {
      payload.orderStatus = [
        OrderStatus.WaitingForAcceptance,
        OrderStatus.Processing,
        OrderStatus.Ready,
        OrderStatus.Delivering,
        OrderStatus.Completed,
        OrderStatus.CancelRejected,
        OrderStatus.Cancelled,
        OrderStatus.Refunding,
        OrderStatus.Refunded,
        OrderStatus.CancelRequested,
        OrderStatus.Rejected,
      ]
      toParams = Object.assign(toParams, {
        startFilterDate: formatterDate(
          new Date(new Date().getTime() - 3600000 * 24 * 183).toUTCString()
        ),
        endFilterDate: formatterDate(
          new Date(new Date().getTime() + 3600000 * 24 * 1).toUTCString()
        ),
      })
    }
    let result = await getMerchorders(toParams, payload.orderStatus)

    // 搜索时订单有退款中的状态时用退款中的订单时替换掉正常的订单
    if (payload.keyword) {
      result = result.map((order: IOrderDto) => {
        return order.hasPendingApprovalRefund
          ? store.state.refundOrderList.find(
              (refundOrder: IOrderCancellationRequestDto) => {
                return refundOrder.order.id === order.id
              }
            )
          : order
      })
    }

    if (payload.noReplaceOrderList) {
      store.commit(
        "handleOrderList",
        [...store.state.orderList, ...result].reduce(
          (arrOrder: IOrderDto[], x: IOrderDto) => {
            let isExistItemIndex = arrOrder.findIndex((o) => o.id === x.id)
            if (isExistItemIndex > -1) {
              arrOrder.splice(isExistItemIndex, 1, x)
              return arrOrder
            }
            return [...arrOrder, x]
          },
          []
        )
      )
    } else {
      store.commit("handleOrderList", result)
    }
    // await getMerchordersCount(toParams)
    commit("handleShowLoading", false)
  },

  async handleRefundOrderList({ commit, state }, merchId?: string) {
    if (state.isPc) {
      const requests = state.merchIds.map((x) => getRefundOrderList(x))
      let resultAll = await Promise.all(requests)
      commit(
        "handleRefundOrderList",
        resultAll
          .reduce(
            (arr: IOrderCancellationRequestDto[], item) => [
              ...arr,
              ...item.data.result,
            ],
            []
          )
          .sort(
            (
              a: IOrderCancellationRequestDto,
              b: IOrderCancellationRequestDto
            ): number =>
              Number(b.order.serialNumber.substring(3)) -
              Number(a.order.serialNumber.substring(3))
          )
      )
      store.commit("handleShowLoading", false)
      return
    }

    let {
      data: { result },
    } = await getRefundOrderList(state.merchId)
    result = result.sort(
      (
        a: IOrderCancellationRequestDto,
        b: IOrderCancellationRequestDto
      ): number =>
        Number(b.order.serialNumber.substring(3)) -
        Number(a.order.serialNumber.substring(3))
    )
    store.commit("handleRefundOrderList", result)
    store.commit("handleShowLoading", false)
  },

  async handleHistoryOrders({ commit, state }, payload: IOrderDto[]) {
    commit("handleHistoryOrder", payload)
  },

  async handlePreOrderList(
    { commit, state },
    payload: {
      page: number
      orderStatus: OrderStatus[]
      date: string
    }
  ) {
    let toParams = {
      startFilterDate: payload.date,
      endFilterDate: payload.date,
      CountStartFilterDate: formatterDate(
        new Date(new Date().getTime() - 3600000 * 24 * 5).toUTCString()
      ),
      CountEndFilterDate: formatterDate(
        new Date(new Date().getTime() + 3600000 * 24 * 1).toUTCString()
      ),
      page: payload.page,
      skip: 5,
      take: 5,
      merchId: "",
      filterType: 3,
      CountFilterType: 0,
    }
    let reslut = await getMerchorders(toParams, payload.orderStatus)
    store.commit("handleOrderList", reslut)
  },
}
export default actions
